<a
    #referIcon
    class="w-full flex flex-col items-center justify-center hover:bg-blurple rounded-lg"
    [class.animation-hi-there]="emphasizeAnimation"
    routerLink="/refer"
    routerLinkActive="!bg-blurple-dark"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    #link="routerLinkActive"
    pTooltip="Refer"
    tooltipPosition="right">
    <fa-icon
        class="text-18 text-white"
        [icon]="faGift"
        [ngClass]="{ hidden: isHovered || link.isActive }" />
    <fa-icon
        class="text-18 text-white"
        [icon]="faGiftSolid"
        [ngClass]="{ hidden: !isHovered && !link.isActive }" />
</a>
